const p = {
    xs: "p-0.5",
    s: "p-xxs",
    m: "p-xs",
    l: "p-s"
}, s = {
    primary: "text-primary",
    secondary: "text-secondary"
}, x = {
    xs: "scroll-pt-[29px]",
    s: "scroll-pt-[33px]",
    m: "scroll-pt-[41px]",
    l: "scroll-pt-[57px]"
}, r = [ 10, 25, 50, 100 ];

export { p as CELL_SPACING, s as COLOR_VARIANT_TEXT_CLASSES, r as DEFAULT_PAGE_OPTIONS, x as SCROLL_PADDING_BY_SPACING };
//# sourceMappingURL=index.js.map
